import size from "../sizes";
import image1 from "../../assets/images/materials/sweatshirt/1.jpg";
import image2 from "../../assets/images/materials/sweatshirt/2.jpg";
import image3 from "../../assets/images/materials/sweatshirt/3.jpg";
import image41 from "../../assets/images/materials/sweatshirt/4-1.jpg";
import image42 from "../../assets/images/materials/sweatshirt/4-2.jpg";
import image5 from "../../assets/images/materials/sweatshirt/5.jpg";
import image6 from "../../assets/images/materials/sweatshirt/6.jpg";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Свитшот из 100% хлопка утеплённый изнутри небольшим начёсом. Мягкий и приятный к телу материал поможет вам чувствовать себя комфортно в любую погоду. Модель прямого кроя.</p>
        <p>Материалы: 100% хлопок, плотность 250 гр/м<sup>2</sup></p>
      `,
      images: [
        {
          source: image1,
          captionContent: {
            title: `100% хлопок`,
            description: `Свитшот шьется из 100% хлопка и проходит 10 этапов контроля качества: от выбора ткани до проверки швов. Горловина обработана удобной резинкой: она хорошо растягивается, поэтому свитшот удобно надевать через голову, но не деформируется со временем благодаря высококачественной рибане.`
          }
        },
        {
          source: image2,
          captionContent: {
            title: `Теплый материал`,
            description: `Ткань изнутри с начесом, поэтому в толстовке тепло в холодную погоду даже без нижнего слоя. Лицевая и изнаночная строчка ровная, нигде не торчат лишние нитки или узелки.`
          }
        },
        {
          source: image3,
          captionContent: {
            title: `Рукава с резинкой`,
            description: `На рукавах удобная резинка, благодаря которой рукава не задираются и хорошо сидят на запястьях. Резинка сшита из качественной рибаны, поэтому она не растягивается от регулярной носки.`
          }
        },
        {
          source: image41,
          captionContent: {
            title: `Классическая посадка`,
            description: `Свитшот шьется из 100% хлопка и проходит 10 этапов контроля качества: от выбора ткани до проверки швов. Горловина обработана удобной резинкой: она хорошо растягивается, поэтому свитшот удобно надевать через голову, но не деформируется со временем благодаря высококачественной рибане.`
          }
        },
        {
          source: image42,
          captionContent: {
            title: `Классическая посадка`,
            description: `Наши свитшоты хорошо сидят на мужчинах и женщинах. Крой унисекс дает небольшой эффект оверсайз, который стильно смотрится в разных дизайнах и делает наши свитшоты чрезвычайно удобными в носке: они не давят и не стесняют движений.`
          }
        },
        {
          source: image5,
          captionContent: {
            title: `Широкий выбор цветов`,
            description: `Разные основные цвета свитшотов позволяют вам проявить творчество и создать уникальный запоминающийся дизайн, который отразит ваше настроение.`
          }
        },
        {
          source: image6,
          captionContent: {
            title: `Простой уход`,
            description: `Стирайте свитшот вывернутым наизнанку при температуре не более 30°С. Гладьте на средней температуре. Не отбеливайте и не подвергайте химчистке. Если соблюдать инструкции по уходу, ваш свитшот прослужит долго.`
          }
        }
      ]
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`sweatshirt`],
      sizeInfo: `sweatshirt`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
